import {createRouter, createWebHashHistory} from 'vue-router';
import LoginView from '@/views/login/index.vue';
import Home from '@/views/home/index.vue';
import {getToken} from '@/utils/auth';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/overview',
      children: [{
        path: '/overview',
        component: () => import('@/views/overview/index.vue'),
        meta: {
          title: 'home.overview',
        },
      }, {
        path: '/plant',
        component: () => import('@/views/plant/index.vue'),
        meta: {
          title: 'home.plant',
        },
      }, {
        path: '/device',
        component: () => import('@/views/device/index.vue'),
        meta: {
          title: 'home.device',
        },
      }, {
        path: '/user',
        component: () => import('@/views/user/index.vue'),
        meta: {
          title: 'home.user',
        },
      }, {
        path: '/agency',
        component: () => import('@/views/agency/index.vue'),
        meta: {
          title: 'home.organization',
        },
      }, {
        path: '/log',
        component: () => import('@/views/log/index.vue'),
        meta: {
          title: 'home.log',
        },
      }, {
        path: '/firmware',
        component: () => import('@/views/firmware/index.vue'),
        meta: {
          title: 'home.firmware',
        },
      }, {
        path: '/instruction',
        component: () => import('@/views/instruction/index.vue'),
        meta: {
          title: 'home.operation',
        },
      }, {
        path: '/inverter',
        component: () => import('@/views/inverter/index.vue'),
        meta: {
          title: 'home.log',
          basePath: ['/device'],
        },
      }, {
        path: '/plant/detail',
        component: () => import('@/views/plant/plantDetail.vue'),
        meta: {
          title: 'home.plantDetail',
          basePath: ['/plant'],
        },
      }, {
        path: '/plant/pcsconfig',
        component: () => import('@/views/plant/pcsconfig.vue'),
        meta: {
          title: 'home.plant',
          basePath: ['/plant'],
        },
      }, {
        path: '/plant/pcsconfigset',
        component: () => import('@/views/plant/pcsconfigset.vue'),
        meta: {
          title: 'home.plant',
          basePath: ['/plant'],
        },
      }, {
        path: '/fault',
        component: () => import('@/views/fault/index.vue'),
        meta: {
          title: 'home.fault',
        },
      }, {
        path: '/fault-config',
        component: () => import('@/views/fault-config/index.vue'),
        meta: {
          title: 'home.fault-config',
        },
      }, {
        path: '/grid',
        component: () => import('@/views/grid/index.vue'),
        meta: {
          title: 'home.gridProfile',
        },
      }],
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        title: 'login.login',
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/forgot-password/index.vue'),
      meta: {
        title: 'login.forgotPassword2',
        withoutToken: true,
      },
    }, {
      path: '/create-account',
      name: 'create-account',
      component: () => import('@/views/create-account/index.vue'),
      meta: {
        title: 'login.createAccount',
        withoutToken: true,
      },
    },
    {
      path: '/404',
      component: () => import('@/views/error-page/404.vue'),
      name: 'Page404',
      meta: { title: '404' },
    },
    // 404 page must be placed at the end !!!
    { path: '/:pathMatch(.*)*', redirect: '/404' },
  ],
});

router.beforeEach((to, from, next) => {
  if (to?.meta?.withoutToken) {
    next();
    return;
  }
  const token = getToken();
  if (token) {
    if (to.path === '/login') {
      next({path: '/'});
    } else {
      next();
    }
  } else if (to.path === '/login') {
    next();
  } else if (to.path && to.path !== '/') {
    next('/login');
  } else {
    next('/login');
  }
});

router.onError(async (error: any) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as any).history.pending.fullPath;
  if (isChunkLoadFailed) {
    await router.replace(targetPath);
  }
});

export default router;
